import React from "react";
import { FormHelperText } from "@material-ui/core";
import clsx from 'clsx';

import useStyles from "./FieldHelperText.style";

export const FieldHelperText = ({
  children,
  className,
  id,
  disabled = false,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  disabled?: boolean;
}) => {
  const c = useStyles({});
  return (
    <FormHelperText className={clsx(c.root, className, 'FieldHelperText', disabled && c.isDisabled)} data-type="ui/FieldHelperText" id={id}>
      {children}
    </FormHelperText>
  );
};
